import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import CheckCircleOutlined from '@material-ui/icons/CheckCircleOutlined';
import WarningAmberOutlined from '@material-ui/icons/ReportProblemOutlined';
import ErrorOutlineOutlined from '@material-ui/icons/ErrorOutline';

const TONE = {
  success: { bg: 'var(--success-soft)', text: 'var(--success-strong)', Icon: CheckCircleOutlined },
  warning: { bg: 'var(--warning-soft)', text: 'var(--warning-strong)', Icon: WarningAmberOutlined },
  danger: { bg: 'var(--danger-soft)', text: 'var(--danger-strong)', Icon: ErrorOutlineOutlined },
  info: { bg: 'var(--info-soft)', text: 'var(--info-strong)', Icon: InfoOutlined },
};

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    borderRadius: 'var(--radius-lg)',
    padding: 'var(--space-4) var(--space-5)',
    marginBottom: 'var(--space-4)',
  },
  icon: {
    display: 'flex',
    marginTop: 1,
    flexShrink: 0,
  },
  title: {
    fontSize: 13,
    fontWeight: 600,
  },
  body: {
    fontSize: 13,
    marginTop: 2,
  },
  action: {
    marginTop: 10,
  },
}));

/** Soft-bg / strong-text / matching icon alert. Replaces per-state notice classes (docs/DESIGN_MAKEOVER.md 7.2). */
const InlineAlert = ({ tone = 'info', title, children, action }) => {
  const classes = useStyles();
  const { bg, text, Icon } = TONE[tone] || TONE.info;
  return (
    <Box className={classes.root} style={{ background: bg, color: text }}>
      <span className={classes.icon}>
        <Icon fontSize="small" />
      </span>
      <Box flex={1} minWidth={0}>
        {title ? <Typography className={classes.title} style={{ color: text }}>{title}</Typography> : null}
        {children ? <Typography className={classes.body} style={{ color: text }}>{children}</Typography> : null}
        {action ? <Box className={classes.action}>{action}</Box> : null}
      </Box>
    </Box>
  );
};

export default InlineAlert;
